
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/tips-and-tricks/t/[slug]",
      function () {
        return require("private-next-pages/inspiration/tips-and-tricks/t/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/tips-and-tricks/t/[slug]"])
      });
    }
  